import React from 'react'

const Label = ({
  src,
  text,
  alt = '',
  className
}: {
  src?: string
  text?: string
  alt: string
  className?: string | null
}) => {
  if (!src || !text) {
    return null
  }
  return (
    <div className={className ? 'label ' + className : 'label'}>
      <img className="label--icon" src={src} alt={alt} />
      <span className="label--text">{text}</span>
    </div>
  )
}

export default Label
